/*
* Copyright (C) Regione Lombardia
*/
export const environment = {
    production: true,
    urlApi: '/ods/api',
};
